import { useState, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import TopBar from "./TopBar";
import ChatbotHeader from "./ChatbotHeader";
import ChatbotBody from "./ChatbotBody";

import "../../styles.css";

interface IProps {
  chatbotSettings: any;
  chatbotAppearance: any;
}

const GeneralPreview = ({ chatbotSettings, chatbotAppearance }: IProps) => {
  const [previewChatbot, setPreviewChatbot] = useState<boolean>(false);

  const handleTogglePreview = () => {
    setPreviewChatbot((prevState) => !prevState);
  };

  return (
    <Box>
      <Typography className="prev-text-titile">
        Chatbot Preview &nbsp;
      </Typography>
      <Typography
        className="zoomicons guideTourViewActualSize"
        sx={{
          color: "#0157FF",
          fontSize: 12,
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={handleTogglePreview}
      >
        Click to preview actual size
      </Typography>
      {previewChatbot && <Box className="settings-overlay" />}
      <Box
        className={`${previewChatbot ? "settings-preview" : ""}`}
        sx={{
          marginTop: "10px",
        }}
      >
        {previewChatbot && (
          <Typography className="for-preview">
            For Preview{" "}
            <span onClick={handleTogglePreview} className="prevclose">
              {" "}
              &nbsp; x &nbsp;Close&nbsp;
            </span>
          </Typography>
        )}
        <Box
          sx={{
            background: chatbotAppearance?.["cuvo-chatbot-header-bg-color"],
          }}
        >
          {/* <Box>
            <TopBar />
          </Box> */}
          <Box mt="24px" p="7px">
            <ChatbotHeader
              chatbotSettings={chatbotSettings}
              chatbotAppearance={chatbotAppearance}
            />
          </Box>
        </Box>

        <ChatbotBody
          chatbotSettings={chatbotSettings}
          chatbotAppearance={chatbotAppearance}
        />
      </Box>
    </Box>
  );
};
export default GeneralPreview;
